import { apiClient as baseApiClient } from '#/api/client.tsx';
import {
  AccountListResponseSchema,
  AccountSchema,
  ResourceOwnerLinkListResponseSchema,
} from '../model.ts';

const cockpitApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit`,
});

const ACCOUNT_INFO_BASE = '/accounts';

export type GetAllAccountsParams = {
  email?: string;
  phoneNumber?: string;
  page?: number;
  pageSize?: number;
};

export const getAllAccounts = async (params: GetAllAccountsParams = {}) => {
  const response = await cockpitApiClient.get(ACCOUNT_INFO_BASE, { params });
  return AccountListResponseSchema.parse(response.data);
};

export const getAccountById = async (id: string) => {
  const response = await cockpitApiClient.get(`${ACCOUNT_INFO_BASE}/${id}`);
  return AccountSchema.parse(response.data.data);
};

export const getAccountResourceOwnerLinks = async (accountId: string) => {
  const response = await cockpitApiClient.get(
    `${ACCOUNT_INFO_BASE}/${accountId}/resource-owner-links`,
  );
  return ResourceOwnerLinkListResponseSchema.parse(response.data).data;
};

export const deleteAccount = async (id: string, reason?: string) => {
  const response = await cockpitApiClient.delete(
    `${ACCOUNT_INFO_BASE}/${id}`,
    reason ? { data: { reason } } : undefined,
  );
  return response.data;
};
